import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'login',
    component: () => import('@/views/Login.vue')
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('@/views/Register.vue')
  },
  {
    path: '/normal',
    name: 'normal',
    component: () => import('@/layouts/Normal.vue'),
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/Dashboard'),
      },
      {
        path: 'profile',
        name: 'profile',
        component: () => import('@/views/Profile.vue')
      },
      {
        path: 'company',
        name: 'company',
        component: () => import('@/views/Company.vue')
      },
      {
        path: 'contact',
        name: 'contact',
        component: () => import('@/views/Contact.vue')
      },
      //
      {
        path: 'portals/rented-count-detail',
        name: 'portalsRentedCountDetail',
        component: () => import('@/views/portals/RentedCountDetail.vue')
      },
      //
      {
        path: 'portals/rent-calendar',
        name: 'portalsRentCalendar',
        component: () => import('@/views/portals/RentCalendar.vue')
      },
      //
      {
        path: 'pdm/products',
        name: 'pdmProducts',
        component: () => import('@/views/pdm/products/index.vue')
      },
      {
        path: 'pdm/products/new',
        name: 'pdmProductsNew',
        component: () => import('@/views/pdm/products/new.vue')
      },
      {
        path: 'pdm/products/new-import',
        name: 'pdmProductsNewImport',
        component: () => import('@/views/pdm/products/newImport.vue')
      },
      //
      {
        path: 'pdm/services',
        name: 'pdmServices',
        component: () => import('@/views/pdm/services/index.vue')
      },
      {
        path: 'pdm/services/new',
        name: 'pdmServicesNew',
        component: () => import('@/views/pdm/services/new.vue')
      },
      //

      //
      {
        path: 'wms/inventories',
        name: 'wmsInventories',
        component: () => import('@/views/wms/inventories/index.vue')
      },
      {
        path: 'wms/search-schedule',
        name: 'wmsSearchSchedule',
        component: () => import('@/views/wms/searchSchedule/index.vue')
      },
      {
        path: 'wms/search-usable-by-schedule',
        name: 'wmsSearchUsableBySchedule',
        component: () => import('@/views/wms/searchUsableBySchedule/index.vue')
      },
      {
        path: 'wms/inventories/check/:shopId',
        name: 'wmsInventoriesCheck',
        component: () => import('@/views/wms/inventories/check.vue')
      },
      {
        path: 'wms/inventories/import/:shopId',
        name: 'wmsInventoriesImport',
        component: () => import('@/views/wms/inventories/import.vue')
      },
      {
        path: 'wms/inventories/batch-stock-in/:shopId',
        name: 'wmsInventoriesBatchStockIn',
        component: () => import('@/views/wms/inventories/batchStockIn.vue')
      },
      {
        path: 'wms/inventories/batch-stock-out/:shopId',
        name: 'wmsInventoriesBatchStockOut',
        component: () => import('@/views/wms/inventories/batchStockOut.vue')
      },
      {
        path: 'wms/stock-ins/count',
        name: 'wmsStockInsCount',
        component: () => import('@/views/wms/stockIns/count.vue')
      },
      {
        path: 'wms/stock-ins',
        name: 'wmsStockIns',
        component: () => import('@/views/wms/stockIns/index.vue')
      },
      {
        path: 'wms/stock-outs/count',
        name: 'wmsStockOutsCount',
        component: () => import('@/views/wms/stockOuts/count.vue')
      },
      {
        path: 'wms/stock-outs',
        name: 'wmsStockOuts',
        component: () => import('@/views/wms/stockOuts/index.vue')
      },
      {
        path: 'wms/allocates',
        name: 'wmsAllocates',
        component: () => import('@/views/wms/allocates/index.vue')
      },
      {
        path: 'wms/allocates/new-in/:shopId',
        name: 'wmsAllocatesNewIn',
        component: () => import('@/views/wms/allocates/newIn.vue')
      },
      {
        path: 'wms/damages',
        name: 'wmsDamages',
        component: () => import('@/views/wms/damages/index.vue')
      },
      //
      {
        path: 'schedules',
        name: 'schedules',
        component: () => import('@/views/schedules/index.vue')
      },
      {
        path: 'schedules/history',
        name: 'schedulesHistory',
        component: () => import('@/views/schedules/history.vue')
      },
      {
        path: 'schedules---',
        name: 'schedules---',
        component: () => import('@/views/schedules/index---.vue')
      },
      //
      {
        path: 'customers',
        name: 'customers',
        component: () => import('@/views/customers/index.vue')
      },
      {
        path: 'customers/import',
        name: 'customersImport',
        component: () => import('@/views/customers/import.vue')
      },
      //
      {
        path: 'rent-packages',
        name: 'rentPackages',
        component: () => import('@/views/rentPackages/index.vue')
      },
      {
        path: 'rent-packages/new',
        name: 'rentPackagesNew',
        component: () => import('@/views/rentPackages/new.vue')
      },
      //
      {
        path: 'rents',
        name: 'rents',
        component: () => import('@/views/rents/index.vue')
      },
      {
        path: 'rents/new-by-rent-package/:rentPackageId',
        name: 'rentsNewByRentPackage',
        component: () => import('@/views/rents/newByRentPackage.vue')
      },
      {
        path: 'rents/new',
        name: 'rentsNew',
        component: () => import('@/views/rents/new.vue')
      },
      {
        path: 'rents/import',
        name: 'rentsImport',
        component: () => import('@/views/rents/import.vue')
      },
      {
        path: 'rents/new-item/:id',
        name: 'rentsNewItem',
        component: () => import('@/views/rents/newItem.vue')
      },
      //
      {
        path: 'services/new-item/:id',
        name: 'servicesNewItem',
        component: () => import('@/views/services/newItem.vue')
      },
      //
      {
        path: 'cleans/new',
        name: 'cleansNew',
        component: () => import('@/views/cleans/new.vue')
      },
      {
        path: 'cleans/new-item/:id',
        name: 'cleansNewItem',
        component: () => import('@/views/cleans/newItem.vue')
      },
      //
      {
        path: 'orders/new',
        name: 'ordersNew',
        component: () => import('@/views/orders/new.vue')
      },
      {
        path: 'orders/new-item/:id',
        name: 'ordersNewItem',
        component: () => import('@/views/orders/newItem.vue')
      },
      //
      {
        path: 'deliveries',
        name: 'deliveries',
        component: () => import('@/views/deliveries/index.vue')
      },
      {
        path: 'downloads',
        name: 'downloads',
        component: () => import('@/views/downloads/index.vue')
      },
      {
        path: 'fn-reports',
        name: 'fnReportsIndex',
        component: () => import('@/views/fnReports/index.vue')
      },
      {
        path: 'fn-reports/schedule-statistics',
        name: 'fnReportsScheduleStatistics',
        component: () => import('@/views/fnReports/scheduleStatistics/index.vue')
      },
      {
        path: 'fn-reports/schedule-statistics/detail',
        name: 'fnReportsScheduleStatisticsDetail',
        component: () => import('@/views/fnReports/scheduleStatistics/detail.vue')
      },
      {
        path: 'fn-reports/schedule-finish-statistics',
        name: 'fnReportsScheduleFinishStatistics',
        component: () => import('@/views/fnReports/scheduleFinishStatistics/index.vue')
      },
      {
        path: 'fn-reports/rent-source-statistics',
        name: 'fnReportsRentSourceStatistics',
        component: () => import('@/views/fnReports/rentSourceStatistics/index.vue')
      },
      {
        path: 'fn-reports/rent-source-statistics/detail',
        name: 'fnReportsRentSourceStatisticsDetail',
        component: () => import('@/views/fnReports/rentSourceStatistics/detail.vue')
      },
      {
        path: 'fn-reports/hot-product-no-statistics',
        name: 'fnReportsHotProductNoStatistics',
        component: () => import('@/views/fnReports/hotProductNoStatistics/index.vue')
      },
      {
        path: 'fn-reports/hot-package-statistics',
        name: 'fnReportsHotPackageStatistics',
        component: () => import('@/views/fnReports/hotPackageStatistics/index.vue')
      },
      {
        path: 'fn-reports/supplier-contribution-statistics',
        name: 'fnReportsSupplierContributionStatistics',
        component: () => import('@/views/fnReports/supplierContributionStatistics/index.vue')
      },
      {
        path: 'fn-reports/supplier-contribution-statistics/detail',
        name: 'fnReportsSupplierContributionStatisticsDetail',
        component: () => import('@/views/fnReports/supplierContributionStatistics/detail.vue')
      },
      {
        path: 'fn-reports/sale-statistics',
        name: 'fnReportsSaleStatistics',
        component: () => import('@/views/fnReports/saleStatistics/index.vue')
      },
      {
        path: 'fn-reports/clean-statistics',
        name: 'fnReportsCleanStatistics',
        component: () => import('@/views/fnReports/cleanStatistics/index.vue')
      },
      {
        path: 'fn-reports/clean-statistics/detail',
        name: 'fnReportsCleanStatisticsDetail',
        component: () => import('@/views/fnReports/cleanStatistics/detail.vue')
      },
    ]
  },
  {
    path: '/set',
    name: 'set',
    component: () => import('@/layouts/Perference.vue'),
    children: [
      {
        path: 'perference/users',
        name: 'perferenceUsers',
        component: () => import('@/views/perference/users/index.vue')
      },
      {
        path: 'perference/auth-templates',
        name: 'perferenceAuthTemplates',
        component: () => import('@/views/perference/authTemplates/index.vue')
      },
      {
        path: 'perference/auth-templates/new',
        name: 'perferenceAuthTemplatesNew',
        component: () => import('@/views/perference/authTemplates/new.vue')
      },
      {
        path: 'perference/shops',
        name: 'perferenceShops',
        component: () => import('@/views/perference/shops/index.vue')
      },
      {
        path: 'perference/pdm/categories',
        name: 'perferencePdmCategories',
        component: () => import('@/views/perference/pdm/categories/index.vue')
      },
      {
        path: 'perference/pdm/categories-serve',
        name: 'perferencePdmCategoriesServe',
        component: () => import('@/views/perference/pdm/categoriesServe/index.vue')
      },
      {
        path: 'perference/pdm/units',
        name: 'perferencePdmUnits',
        component: () => import('@/views/perference/pdm/units/index.vue')
      },
      {
        path: 'perference/pdm/colors',
        name: 'perferencePdmColors',
        component: () => import('@/views/perference/pdm/colors/index.vue')
      },
      {
        path: 'perference/pdm/sizes',
        name: 'perferencePdmSizes',
        component: () => import('@/views/perference/pdm/sizes/index.vue')
      },
      {
        path: 'perference/pdm/brands',
        name: 'perferencePdmBrands',
        component: () => import('@/views/perference/pdm/brands/index.vue')
      },
      {
        path: 'perference/pay-methods',
        name: 'perferencePayMethods',
        component: () => import('@/views/perference/payMethods/index.vue')
      },
      {
        path: 'perference/schedule-types',
        name: 'perferenceScheduleTypes',
        component: () => import('@/views/perference/scheduleTypes/index.vue')
      },
      {
        path: 'perference/rent-templates',
        name: 'perferenceRentTemplates',
        component: () => import('@/views/perference/rentTemplates/index.vue')
      },
      {
        path: 'perference/rent-templates/new',
        name: 'perferenceRentTemplatesNew',
        component: () => import('@/views/perference/rentTemplates/new.vue')
      },
      {
        path: 'perference/rent-templates/edit/:id',
        name: 'perferenceRentTemplatesEdit',
        component: () => import('@/views/perference/rentTemplates/edit.vue')
      },
      {
        path: 'perference/suppliers',
        name: 'perferenceSuppliers',
        component: () => import('@/views/perference/suppliers/index.vue')
      },
      {
        path: 'perference/sources',
        name: 'perferenceSources',
        component: () => import('@/views/perference/sources/index.vue')
      },
      {
        path: 'perference/settings',
        name: 'perferenceSettings',
        component: () => import('@/views/perference/settings/index.vue')
      },
    ]
  },
  // {
  //   path: '/fnReport',
  //   name: 'fnReport',
  //   component: () => import('@/layouts/FNReport.vue'),
  //   children: [
  //     {
  //       path: 'fn-reports/reports',
  //       name: 'fnReportsReportsIndex',
  //       component: () => import('@/views/fnReports/index.vue')
  //     },
  //   ]
  // },
  {
    path: '/help',
    name: 'help',
    component: () => import('@/views/Help.vue')
  },
  {
    path: '/*',
    name: '404',
    component: () => import('@/views/404.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default router
